import React, { useState, useEffect } from "react";
import config from "../../config";

function ToolsetButtonLister({
  environment,
  toolsetSubsetList,
  isPro,
  selectedToolset,
  setSelectedToolset,
  toolSelected,
  setToolSelected,
}) {
  return (
    <>
      <div
        className="cs1 ce12 grid z-front"
        style={{
          display: toolSelected ? "none" : "block",
        }}>
        {toolsetSubsetList.forEach((toolSet) => {
          return toolSet.toolset_name;
        })}
      </div>
      {toolsetSubsetList.map((toolset, index) => {
        return (
          <div id="toolset-button-container" key={toolset.toolset_name}>
            <div>
              <div
                className={"grid mb-24 toolbutton height-48 pos-rel add-shadow"}
                style={{
                  cursor:
                    toolset.status_prod_ready != true ? "default" : "pointer",
                  // backgroundImage:
                  //   `url(${toolset?.toolbutton_bkg_image_url})` || "",
                  // backgroundSize: "352px",
                  // backgroundPosition: "-4100% 50%",
                }}
                onClick={() => {
                  if (
                    toolset.status_prod_ready === true ||
                    // (toolset.pro_tools_in_set === ("some" || "all") && isPro) ||
                    (toolset.status_UAT_ready === true && environment === "beta")
                  ) {
                    // set the scroll to top (so if we've scrolled down the toolkit list, our scroll starts back at the top of a tool)
                    let scrollDiv = document.getElementById("sidebar-content");
                    scrollDiv.scrollTop = 0;
                    setSelectedToolset(toolset);
                    setToolSelected(true);
                  }
                }}>
                <div
                  className={
                    "cs1 icon m2 " + `${toolset.toolset_icon_classname}`
                  }></div>
                <h3 className="cs2 ce12 h3 mt-0 mb-0 tool-button-text">
                  {toolset.toolset_name}
                </h3>
                {!(
                  toolset.status_prod_ready === true ||
                  (toolset.pro_tools_in_set === ("some" || "all") && isPro) ||
                  (toolset.status_UAT_ready === true && environment === "beta")
                ) ? (
                  <div className="centered-overlay crosshatch">
                    {/* <span
                      style={{
                        display:
                          toolset.pro_tools_in_set === ("some" || "all")
                            ? " block"
                            : " none !important",
                      }}
                      onClick={() =>
                        window.open(
                          "https://www.visualthinking.tools/powerpack-feedback/#comp-l3alhyjs",
                          "_blank"
                        )
                      }
                      className="p-small pro-upgrade">
                      {toolset.statusMessage}
                    </span> */}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default ToolsetButtonLister;
